import React from 'react';
import { StepViewModel } from '../../models/step';
import { InputType } from '../../enums/input-type.enum';
import { ColorPickerViewRender } from '../../views/ColorPickerViewRender';
import { BraSizePickerViewRender } from '../../views/BraSizePickerViewRender';
import { SizeViewRender } from '../../views/SizeViewRender';
import { FinalSizeViewRender } from '../../views/FinalSizeViewRender';
import { AdditionalBraSizeViewRender } from '../../views/AdditionalBraSizeViewRender';
import { StepValues } from '../../models/step-values';
import { getSuggestedTankSizeFromBraSize } from '../../utils/bra-helper';

export const LiftWearTankSteps: StepViewModel[] = [
  {
    key: 'bra',
    text: 'What is your bra size?',
    progress: 0,
    options: [
      {
        text: '',
        nextStepKey: 'bra-additional',
      },
      {
        text: '',
        nextStepKey: 'not-ready',
      },
    ],
    render: (props, onChange) => {
      return (
        <BraSizePickerViewRender
          {...props}
          onChange={onChange}
          key={'bra'}
          nextStepKey={'bra-additional'}
          unsupportedStepKey={'not-ready'}
          braSizeLookupFn={getSuggestedTankSizeFromBraSize}
        />
      );
    },
  },
  {
    key: 'bra-additional',
    text: 'Do you ever wear a larger bra size than {bra}?',
    subText: 'Which of these two sizes would fit you better?',
    progress: 14,
    bypass: (stepValues: StepValues): string => {
      const braResult = stepValues.get('bra');
      if (braResult && (braResult.text === '46DDD/F' || braResult.text === '48DD/E' || braResult.text === '48DDD/F' || braResult.text === '48G')) {
        return 'fitted-tops';
      }
      return '';
    },
    options: [
      {
        text: '',
        nextStepKey: 'fitted-tops',
      },
    ],
    render: (props, onChange) => {
      return <AdditionalBraSizeViewRender {...props} onChange={onChange} nextStepKey={'fitted-tops'} braKey={'bra'} />;
    },
  },
  {
    key: 'fitted-tops',
    progress: 28,
    text: 'What size do you wear in other fitted tank tops?',
    options: [
      {
        text: 'XS',
        nextStepKey: 'initial-size',
      },
      {
        text: 'S',
        nextStepKey: 'initial-size',
      },
      {
        text: 'M',
        nextStepKey: 'initial-size',
      },
      {
        text: 'L',
        nextStepKey: 'initial-size',
      },
      {
        text: 'XL',
        nextStepKey: 'initial-size',
      },
      {
        text: '1X',
        nextStepKey: 'initial-size',
      },
      {
        text: '2X',
        nextStepKey: 'initial-size',
      },
      {
        text: '3X',
        nextStepKey: 'initial-size',
      },
      // {
      //   text: '4X',
      //   nextStepKey: 'dress',
      // },
      // {
      //   text: '5X',
      //   nextStepKey: 'dress',
      // },
    ],
  },
  {
    key: 'initial-size',
    text: 'initial-size',
    progress: 42,
    options: [
      {
        text: 'Pick a color',
        inputType: InputType.Button,
        nextStepKey: 'pick-a-color',
      },
      {
        text: 'Get more accurate sizing',
        inputType: InputType.Button,
        nextStepKey: 'hook',
      },
    ],
    render: (props, onChange) => {
      return <SizeViewRender {...props} onChange={onChange} />;
    },
  },
  {
    key: 'not-ready',
    text: `Hey love,

Our design team is still working on the bra size {bra}, and it's not available yet.

If you'd like to be notified as soon as our expanded sizes launch, please leave your email below.

Alternatively, you can order the tank in size 3X - if that's not the right size, we have an excellent return policy :)`,
    progress: 99,
    options: [
      {
        inputType: InputType.Email,
        nextStepKey: 'results',
        klaviyoKey: 'klaviyo4x5xId',
      },
      {
        inputType: InputType.SecondaryCTAButton,
        nextStepKey: 'pick-a-color',
        text: 'ORDER IN SIZE 3X',
      },
      // {
      //   text: 'View my size',
      //   inputType: InputType.CTAButton,
      //   nextStepKey: 'results',
      // },
    ],
  },
  {
    key: 'hook',
    progress: 56,
    text: 'Which hook on your bra do you use most often?',
    options: [
      {
        text: 'Tightest',
        nextStepKey: 'dress',
      },
      {
        text: 'Middle',
        nextStepKey: 'dress',
      },
      {
        text: 'Loosest',
        nextStepKey: 'dress',
      },
    ],
  },

  {
    key: 'dress',
    progress: 70,
    text: "What's your dress size?",
    options: [
      {
        text: "I don't know",
        nextStepKey: 'kind-of-fit',
      },
      {
        text: '2',
        nextStepKey: 'kind-of-fit',
      },
      {
        text: '4',
        nextStepKey: 'kind-of-fit',
      },
      {
        text: '6',
        nextStepKey: 'kind-of-fit',
      },
      {
        text: '8',
        nextStepKey: 'kind-of-fit',
      },
      {
        text: '10',
        nextStepKey: 'kind-of-fit',
      },
      {
        text: '12',
        nextStepKey: 'kind-of-fit',
      },
      {
        text: '14',
        nextStepKey: 'kind-of-fit',
      },
      {
        text: '16',
        nextStepKey: 'kind-of-fit',
      },
      {
        text: '18',
        nextStepKey: 'kind-of-fit',
      },
      {
        text: '20',
        nextStepKey: 'kind-of-fit',
      },
      {
        text: '22',
        nextStepKey: 'kind-of-fit',
      },
      {
        text: '24',
        nextStepKey: 'kind-of-fit',
      },
    ],
  },
  {
    key: 'kind-of-fit',
    text: 'What kind of fit do you like in your clothing?',
    progress: 84,
    options: [
      {
        text: 'Snug fit',
        nextStepKey: 'height',
      },
      {
        text: 'Middle',
        nextStepKey: 'height',
      },
      {
        text: 'I like some space',
        nextStepKey: 'height',
      },
    ],
  },
  {
    key: 'height',
    text: 'How tall are you?',
    progress: 90,
    options: [
      {
        imperialText: '5\'0" or below',
        metricText: '150 cm or below',
        nextStepKey: 'results',
      },
      {
        imperialText: '5\'1"',
        metricText: '155 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '5\'2"',
        metricText: '157 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '5\'3"',
        metricText: '160 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '5\'4"',
        metricText: '163 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '5\'5"',
        metricText: '165 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '5\'6"',
        metricText: '168 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '5\'7"',
        metricText: '170 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '5\'8"',
        metricText: '173 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '5\'9"',
        metricText: '175 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '5\'10"',
        metricText: '178 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '5\'11"',
        metricText: '180 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '6\'0"',
        metricText: '183 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '6\'1"',
        metricText: '185 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '6\'2"',
        metricText: '188 cm or above',
        nextStepKey: 'results',
      },
    ],
  },
  {
    key: 'results',
    text: '[engine]',
    subText: 'Do you agree with our recommendation?',
    progress: 95,
    options: [
      {
        text: '',
        nextStepKey: 'pick-a-color',
      },
    ],
    render: (props, onChange) => {
      return <FinalSizeViewRender {...props} nextStepKey="pick-a-color" onChange={onChange} />;
    },
  },
  {
    key: 'pick-a-color',
    text: 'pick-a-color',
    progress: 100,
    options: [],
    render: (props, onChange) => {
      return <ColorPickerViewRender {...props} onChange={onChange} />;
    },
  },
];
